<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <!-- <v-img
          :src="require('../assets/logo.svg')"
          class="my-3"
          contain
          height="200"
        /> -->
        <v-icon large color="primary" class="large-icon hidden-xs-only"
          >mdi-subway</v-icon
        >
        <v-icon large color="primary" class="small-icon hidden-sm-and-up"
          >mdi-subway</v-icon
        >
        <br />
        <svg height="20" width="340">
          <a href="https://twitter.com/bakerlooline">
            <line x1="10" y1="10" x2="30" y2="10" class="line Bakerloo" />
          </a>
          <a href="https://twitter.com/centralline">
            <line x1="40" y1="10" x2="60" y2="10" class="line Central" />
          </a>
          <a href="https://twitter.com/circleline">
            <line x1="70" y1="10" x2="90" y2="10" class="line Circle" />
          </a>
          <a href="https://twitter.com/districtline">
            <line x1="100" y1="10" x2="120" y2="10" class="line District" />
          </a>
          <a href="https://twitter.com/hamandcityline">
            <line
              x1="130"
              y1="10"
              x2="150"
              y2="10"
              class="line HammersmithCity"
            />
          </a>
          <a href="https://twitter.com/jubileeline">
            <line x1="160" y1="10" x2="180" y2="10" class="line Jubilee" />
          </a>
          <a href="https://twitter.com/metline">
            <line x1="190" y1="10" x2="210" y2="10" class="line Metropolitan" />
          </a>
          <a href="https://twitter.com/northernline">
            <line x1="220" y1="10" x2="240" y2="10" class="line Northern" />
          </a>
          <a href="https://twitter.com/piccadillyline">
            <line x1="250" y1="10" x2="270" y2="10" class="line Piccadilly" />
          </a>
          <a href="https://twitter.com/victorialine">
            <line x1="280" y1="10" x2="300" y2="10" class="line Victoria" />
          </a>
          <a href="https://twitter.com/wlooandcityline">
            <line x1="310" y1="10" x2="330" y2="10" class="line WaterlooCity" />
          </a>
        </svg>
      </v-col>

      <v-col class="mb-4" cols="12">
        <h1 class="display-2 font-weight-bold mb-3 hidden-xs-only">
          How busy is the tube?
        </h1>
        <h1 class="font-weight-bold mb-3 hidden-sm-and-up small-header">
          How busy is the tube?
        </h1>
        <p class="subheading font-weight-regular">
          Check your route and know when to travel
        </p>
      </v-col>

      <v-col cols="12">
        <!-- <v-col v-if="!load" cols="12"> -->
        <div class="mb-5">
          <h2 class="headline font-weight-bold mb-3">
            From
          </h2>
          <v-autocomplete
            v-model="depatureStationModel"
            :items="depatureItems"
            :loading="isLoading"
            :search-input.sync="depatureSearch"
            color="white"
            hide-no-data
            hide-selected
            item-text="StationName"
            item-value="API"
            label="Departure Station"
            placeholder="Start typing to Search"
            return-object
            class="full-width"
          ></v-autocomplete>
        </div>

        <div class="mb-5">
          <h2 class="headline font-weight-bold mb-3">
            To
          </h2>
          <v-autocomplete
            v-model="arrivalStationModel"
            :items="arrivalItems"
            :loading="isLoading"
            :search-input.sync="arrivalSearch"
            color="white"
            hide-no-data
            hide-selected
            item-text="StationName"
            item-value="API"
            label="Arrival Station"
            placeholder="Start typing to Search"
            return-object
            class="full-width"
          ></v-autocomplete>
        </div>
        <div class="mb-5">
          <!-- <v-btn :disabled="!twoStationsSelected || sameStation" @click="isUpdating = true"> -->
          <v-btn
            class="mb-4"
            :disabled="!twoStationsSelected || sameStation"
            @click="
              getLoadFromAPI(depatureStationModel.ICS, arrivalStationModel.ICS)
            "
            color="primary"
          >
            <!-- <v-icon left>mdi-update</v-icon> -->
            Check
          </v-btn>
          <br />
          <div v-if="fetching" class="mb-4 lds-ripple Primary">
            <div></div>
            <div></div>
          </div>
          <br />
          <span v-if="sameStation" class="red--text text--lighten-1"
            >Departure and arrival station can't be the same<br
          /></span>
          <span v-if="fetchError" class="red--text text--lighten-1"
            >There was a problem getting the crowding on this route
            <br />
            We're still ironing out a few issues</span
          >
          <span v-if="helpfulMessage != null" class="red--text text--lighten-1"
            >{{ helpfulMessage }}
            <br />
            We're working on including this in the next release.
            <br />
            Tweet us and let us know this is a feature you'd like.
          </span>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <h4 v-if="load != null">
          TfL recommended route<TfLHelpModal></TfLHelpModal>
        </h4>
      </v-col>

      <v-col
        class="mb-5 hidden-xs-only"
        cols="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
      >
        <!-- <div class="smaller-picker" v-if="load !=null" cols="12">
          <div class="mb-5">
            <h2 class="headline font-weight-bold mb-3">
              From
            </h2>
            <v-autocomplete
              v-model="depatureStationModel"
              :items="depatureItems"
              :loading="isLoading"
              :search-input.sync="depatureSearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="StationName"
              item-value="API"
              label="Departure Station"
              placeholder="Start typing to Search"
              return-object
              class="full-width"
            ></v-autocomplete>
          </div>

          <div class="mb-5">
            <h2 class="headline font-weight-bold mb-3">
              To
            </h2>
            <v-autocomplete
              v-model="arrivalStationModel"
              :items="arrivalItems"
              :loading="isLoading"
              :search-input.sync="arrivalSearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="StationName"
              item-value="API"
              label="Arrival Station"
              placeholder="Start typing to Search"
              return-object
              class="full-width"
            ></v-autocomplete>
          </div>
          <div class="mb-10">
            <v-btn :disabled="!twoStationsSelected || sameStation" @click="isUpdating = true">
            <v-btn :disabled="!twoStationsSelected || sameStation" @click="getLoadFromAPI(depatureStationModel.StationName, arrivalStationModel.StationName)">
              <v-icon left>mdi-update</v-icon>
              Check
            </v-btn>
            <br>
            <span v-if="sameStation" class="red--text text--lighten-1">Departure and arrival station can't be the same</span>
            <span v-if="fetchError" class="red--text text--lighten-1">There was a problem getting the crowding on this route</span>
          </div>
        </div> -->
        <div v-if="load != null">
          <!-- <p>{{load.load}}</p><br> -->
          <h1 class="mb-4">Crowding for the next two hours</h1>
          <!-- <h4>Specific for your journey {{depatureStationModel.StationName}} to {{arrivalStationModel.StationName}}</h4> -->
          <span v-for="l in load.load" :key="l.timeslot">
            <div class="depatureSlotContainer">
              <svg height="200" width="70">
                <line
                  x1="15"
                  y1="10"
                  x2="55"
                  y2="10"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 10)]"
                />
                <line
                  x1="15"
                  y1="30"
                  x2="55"
                  y2="30"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 9)]"
                />
                <line
                  x1="15"
                  y1="50"
                  x2="55"
                  y2="50"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 8)]"
                />
                <line
                  x1="15"
                  y1="70"
                  x2="55"
                  y2="70"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 7)]"
                />
                <line
                  x1="15"
                  y1="90"
                  x2="55"
                  y2="90"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 6)]"
                />
                <line
                  x1="15"
                  y1="110"
                  x2="55"
                  y2="110"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 5)]"
                />
                <line
                  x1="15"
                  y1="130"
                  x2="55"
                  y2="130"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 4)]"
                />
                <line
                  x1="15"
                  y1="150"
                  x2="55"
                  y2="150"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 3)]"
                />
                <line
                  x1="15"
                  y1="170"
                  x2="55"
                  y2="170"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 2)]"
                />
                <line
                  x1="15"
                  y1="190"
                  x2="55"
                  y2="190"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 1)]"
                />
              </svg>
              <span class="timeSlotText">{{ l.timeSlot }}</span>
            </div>
          </span>
        </div>
      </v-col>

      <v-col
        class="mb-5 hidden-sm-and-up"
        cols="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
      >
        <div v-if="load != null" class="smallScreen">
          <!-- <p>{{load.load}}</p><br> -->
          <h1>Crowding for the next two hours</h1>
          <!-- <h4>Specific for your journey {{depatureStationModel.StationName}} to {{arrivalStationModel.StationName}}</h4> -->
          <span v-for="l in load.load" :key="l.timeslot">
            <div class="depatureSlotContainer">
              <svg height="200" width="35">
                <line
                  x1="15"
                  y1="10"
                  x2="30"
                  y2="10"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 10)]"
                />
                <line
                  x1="15"
                  y1="30"
                  x2="30"
                  y2="30"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 9)]"
                />
                <line
                  x1="15"
                  y1="50"
                  x2="30"
                  y2="50"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 8)]"
                />
                <line
                  x1="15"
                  y1="70"
                  x2="30"
                  y2="70"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 7)]"
                />
                <line
                  x1="15"
                  y1="90"
                  x2="30"
                  y2="90"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 6)]"
                />
                <line
                  x1="15"
                  y1="110"
                  x2="30"
                  y2="110"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 5)]"
                />
                <line
                  x1="15"
                  y1="130"
                  x2="30"
                  y2="130"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 4)]"
                />
                <line
                  x1="15"
                  y1="150"
                  x2="30"
                  y2="150"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 3)]"
                />
                <line
                  x1="15"
                  y1="170"
                  x2="30"
                  y2="170"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 2)]"
                />
                <line
                  x1="15"
                  y1="190"
                  x2="30"
                  y2="190"
                  class="line Primary"
                  v-bind:class="[isBusyJourney(l.load, 1)]"
                />
              </svg>
              <span class="timeSlotText rotate">{{ l.timeSlot }}</span>
            </div>
          </span>
        </div>
      </v-col>

      <v-col class="mb-5" cols="12" sm="12" md="12" lg="6" xl="6">
        <div v-if="load != null">
          <h1>
            Journey details for depatures after
          </h1>
          <div class="time-alter mb-4">
            <div class="mr-8" @click="updateDetailIndex(-1)">
              <!-- Earlier -->
              <v-icon
                large
                class="later-time"
                color="primary"
                :disabled="!(detailIndex > 0)"
                >mdi-sort-clock-descending-outline</v-icon
              >
            </div>
            <h1>{{ load.load[this.detailIndex].timeSlot }}</h1>
            <!-- <span v-if="detailIndex > 0" @click="updateDetailIndex(-1)">
              |
            </span> -->
            <div class="ml-8" @click="updateDetailIndex(1)">
              <v-icon
                large
                class="later-time"
                color="primary"
                :disabled="!(detailIndex < load.load.length - 1)"
                >mdi-sort-clock-ascending-outline</v-icon
              >
            </div>
          </div>
          <h2>{{ load.details[this.detailIndex][0].departStation }}</h2>
          <br />
          <span
            v-for="i in load.details[this.detailIndex]"
            :key="i.departStation"
          >
            <!-- <h4>{{i.line}}</h4> -->
            <!-- <svg height="20" width="190">
              <line x1="10" y1="10" x2="180" y2="10" class="line" v-bind:class="i.line"/>
            </svg>
            <br> -->
            <span v-if="i.mode == 'Tube'">
            <svg height="20" width="190">
              <line
                x1="10"
                y1="10"
                x2="30"
                y2="10"
                class="line"
                v-bind:class="[lineParser(i.line), isBusy(i.load, 1)]"
              />
              <line
                x1="40"
                y1="10"
                x2="60"
                y2="10"
                class="line"
                v-bind:class="[lineParser(i.line), isBusy(i.load, 2)]"
              />
              <line
                x1="70"
                y1="10"
                x2="90"
                y2="10"
                class="line"
                v-bind:class="[lineParser(i.line), isBusy(i.load, 3)]"
              />
              <line
                x1="100"
                y1="10"
                x2="120"
                y2="10"
                class="line"
                v-bind:class="[lineParser(i.line), isBusy(i.load, 4)]"
              />
              <line
                x1="130"
                y1="10"
                x2="150"
                y2="10"
                class="line"
                v-bind:class="[lineParser(i.line), isBusy(i.load, 5)]"
              />
              <line
                x1="160"
                y1="10"
                x2="180"
                y2="10"
                class="line"
                v-bind:class="[lineParser(i.line), isBusy(i.load, 6)]"
              />
            </svg>
            </span>
            <span v-if="i.mode == 'Walking'">
              <v-icon
                large
                >mdi-walk
              </v-icon>
              <span v-if="load.details[0].length == 1" class="grey--text text--lighten-1">
                <br>
                {{distanceFormatted(i.distance)}}
                <br>
                TfL recommends you walk
              </span>
            </span>
            <span v-if="i.mode == 'Bus'">
              <v-icon
                large
                >mdi-bus
              </v-icon>
              <span class="grey--text text--lighten-1">
                <br>
                More bus details coming soon
              </span>
            </span>
            <br />
            <!-- <h4>{{i.load}}</h4> -->
            <br />
            <h2>{{ i.arriveStation }}</h2>
            <br />
          </span>
        </div>
      </v-col>
<!-- 
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="my-10"> </v-col> -->
    </v-row>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
        <span v-if="load != null">
          <v-alert v-if="load.notices.length > 0" dense text dark color="primary">
            <span v-for="notice in load.notices" :key="notice"><v-icon color="primary"
              >mdi-alert-circle-outline</v-icon>
              {{notice}}
              <br>
            </span>
          </v-alert>
        </span>
      </v-col>
    </v-row>
    <v-footer color="white">
      <!-- <h2 class="headline font-weight-bold mb-3">
            Important Links
          </h2> -->
      <v-row justify="center">
        <v-col cols="12">
          <v-divider class="mb-5 mx-10"></v-divider>
          <!-- <h2 class="headline font-weight-bold mb-3">
                Important Links
              </h2> -->
          <v-row justify="center">
            <about-modal />
            <a
              v-for="(link, i) in importantLinks"
              :key="i"
              :href="link.href"
              class="subheading mx-3"
              target="_blank"
            >
              {{ link.text }}
            </a>
          </v-row>
        </v-col>
        <!-- <v-col cols="12">
          <v-row justify="center">
            <v-btn
              x-small
              @click="changeColor('#1976D2')"
              color="#1976D2"
              class="mx-1"
              >Default</v-btn
            >
            <v-btn
              x-small
              @click="changeColor('#8C8074')"
              color="#8C8074"
              class="mx-1"
              >#8C8074</v-btn
            >
            <v-btn
              x-small
              @click="changeColor('#8697A6')"
              color="#8697A6"
              class="mx-1"
              >#8697A6</v-btn
            >
            <v-btn
              x-small
              @click="changeColor('#51608C')"
              color="#51608C"
              class="mx-1"
            >
              #51608C</v-btn
            >
            <v-btn
              x-small
              @click="changeColor('#F27405')"
              color="#F27405"
              class="mx-1"
              >#F27405</v-btn
            >
            <v-btn
              x-small
              @click="changeColor('#0A87C7')"
              color="#0A87C7"
              class="mx-1"
              >#0A87C7</v-btn
            >
            <v-btn
              x-small
              @click="changeColor('#0019A8')"
              color="#0019A8"
              class="mx-1"
              >#0019A8</v-btn
            >
          </v-row>
        </v-col> -->
      </v-row>
    </v-footer>
  </v-container>
</template>

<script>
import stations from "@/assets/stations.json";
// import axios from "axios";
import AboutModal from "@/components/AboutModal.vue";
import TfLHelpModal from "@/components/TfLHelpModal.vue";
export default {
  name: "HelloWorld",
  components: {
    AboutModal,
    TfLHelpModal
  },
  data: () => ({
    importantLinks: [
      {
        text: "Latest from TfL",
        href: "https://twitter.com/TfL"
      },
      {
        text: "Buy Us A Coffee",
        href: "https://www.buymeacoffee.com/oscar28"
      }
    ],
    entries: [],
    isLoading: false,
    depatureStationModel: null,
    arrivalStationModel: null,
    depatureSearch: null,
    arrivalSearch: null,
    detailIndex: 0,
    fetchError: false,
    fetching: false,
    helpfulMessage: null,
    load: null,
  }),

  computed: {
    depatureItems() {
      return this.entries.map(entry => {
        const StationName =
          entry.StationName.length > this.descriptionLimit
            ? entry.StationName.slice(0, this.descriptionLimit) + "..."
            : entry.StationName;

        return Object.assign({}, entry, { StationName });
      });
    },
    arrivalItems() {
      return this.entries.map(entry => {
        const StationName =
          entry.StationName.length > this.descriptionLimit
            ? entry.StationName.slice(0, this.descriptionLimit) + "..."
            : entry.StationName;

        return Object.assign({}, entry, { StationName });
      });
    },
    twoStationsSelected() {
      if (this.depatureStationModel && this.arrivalStationModel) {
        return true;
      }
      return false;
    },
    sameStation() {
      if (
        this.depatureStationModel !== null &&
        this.arrivalStationModel !== null
      ) {
        if (this.depatureStationModel.ICS == this.arrivalStationModel.ICS) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    this.entries = stations;
  },
  watch: {
    depatureSearch() {
      // Items have already been loaded
      if (this.depatureItems.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = false;
    },
    arrivalSearch() {
      // Items have already been loaded
      if (this.arrivalItems.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = false;
    }
  },

  methods: {
    getLoadFromAPI(departStation, arriveStation) {
      var myHeaders = new Headers();
      myHeaders.append("x-api-key", process.env.VUE_APP_WEB_APP_API);

      const options = {
        method: "GET",
        headers: myHeaders,
        mode: "cors",
        redirect: "follow"
      };

      this.fetching = true;
      this.fetchError = false;

      fetch(
        `https://8ug5qktm1b.execute-api.eu-west-1.amazonaws.com/prod/rideflixload?fromics=${departStation}&toics=${arriveStation}`,
        options
      )
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if ("type" in data) {
            if (data.type == "Not complete") {
              this.helpfulMessage = data.message;
            }
          } else {
            this.load = data;
            console.log(data);
            this.helpfulMessage = null;
          }
        })
        .catch(error => {
          this.fetchError = true;
          console.error("Error:", error);
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    lineParser(str) {
      str = str.replace(/\s+/g, "");
      return str.replace(/&/g, "");
    },
    isBusy(load, metric) {
      if (load >= metric / 6) {
        return "busy";
      } else if (load == 0) {
        return "unknown";
      }
      return "empty";
    },
    isBusyJourney(load, metric) {
      if (load >= metric / 10) {
        return "busy";
      }
      return "empty";
    },
    updateDetailIndex(change) {
      this.detailIndex = this.detailIndex + change;
    },
    changeColor(colorPick) {
      this.$vuetify.theme.themes.light.primary = colorPick;
    },
    distanceFormatted(distance) {
      if (distance < 1000){
        return `${distance}m`
      } else {
        return `${Math.round((distance/1000) * 10) / 10}km`
      }
    }
  }
};
</script>
<style scoped>
.line {
  stroke-width: 5;
  stroke-linecap: round;
}
/* */
.Bakerloo {
  stroke: rgb(178, 99, 0);
}
.Central {
  stroke: rgb(220, 36, 31);
}
.Circle {
  stroke: rgb(255, 211, 41);
}
.District {
  stroke: rgb(0, 125, 50);
}
.HammersmithCity {
  stroke: rgb(244, 169, 190);
}
.Jubilee {
  stroke: rgb(161, 165, 167);
}
.Metropolitan {
  stroke: rgb(155, 0, 88);
}
.Northern {
  stroke: rgb(0, 0, 0);
}
.Piccadilly {
  stroke: rgb(0, 25, 168);
}
.Victoria {
  stroke: rgb(0, 152, 216);
}
.WaterlooCity {
  stroke: rgb(147, 206, 186);
}
.Primary {
  stroke: rgb(25, 117, 210);
  /* stroke: rgb(63, 81, 181); */
  /* stroke: rgb(10, 135, 199); */
}
.empty {
  opacity: 35%;
  -moz-opacity: 0.35; /* Firefox and Mozilla browsers */
  -webkit-opacity: 0.35; /* WebKit browser e.g. Safari */
  filter: alpha(opacity=35); /* For IE8 and earlier */
}
.unknown {
  opacity: 15%;
  -moz-opacity: 0.15; /* Firefox and Mozilla browsers */
  -webkit-opacity: 0.15; /* WebKit browser e.g. Safari */
  filter: alpha(opacity=15); /* For IE8 and earlier */
  stroke: rgb(0, 0, 0) !important;
}
.depatureSlotContainer {
  display: inline-grid;
  margin-left: 1px;
  margin-right: 1px;
}

.smallScreen .timeSlotText {
  transform: rotate(-90deg);
  margin-left: 6px;
  margin-right: 0px;
  margin-top: 12px;
  font-size: 0.8em;
}

.smallScreen .depatureSlotContainer {
  margin-left: 0px;
  margin-right: 0px;
}

.full-width {
  max-width: 600px;
  margin: auto;
}

.small-header {
  font-size: 2em !important;
}

.large-icon {
  font-size: 12em !important;
  border-radius: 100px;
}

.small-icon {
  font-size: 5em !important;
}

.smaller-picker {
  border-right: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.later-time {
  transform: rotate(-90deg);
}

.time-alter {
  display: inline-flex;
}
</style>
<style>
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
}
.lds-ripple div {
  position: absolute;
  border: 2px solid rgb(25, 117, 210);
  /* border: 2px solid rgb(10, 135, 199); */
  opacity: 1;
  -moz-opacity: 1; /* Firefox and Mozilla browsers */
  -webkit-opacity: 1; /* WebKit browser e.g. Safari */
  filter: alpha(opacity=1); /* For IE8 and earlier */
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 18px;
    left: 18px;
    width: 0;
    height: 0;
    opacity: 1;
    -moz-opacity: 1; /* Firefox and Mozilla browsers */
    -webkit-opacity: 1; /* WebKit browser e.g. Safari */
    filter: alpha(opacity=1); /* For IE8 and earlier */
  }
  100% {
    top: 0px;
    left: 0px;
    width: 36px;
    height: 36px;
    opacity: 0;
    -moz-opacity: 0; /* Firefox and Mozilla browsers */
    -webkit-opacity: 0; /* WebKit browser e.g. Safari */
    filter: alpha(opacity=0); /* For IE8 and earlier */
  }
}
</style>
